var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysician(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.858,
    height: 128,
    viewBox: "0 0 93.858 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "physician",
    transform: "translate(-2.646 -280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7587",
    d: "M34.637,280.6A29.849,29.849,0,0,0,4.762,310.454V357.4H64.5V310.454A29.834,29.834,0,0,0,34.637,280.6Z",
    transform: "translate(14.943 0)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7542",
    d: "M30.38,289.063A27.716,27.716,0,0,0,2.646,316.792V346.65a2.134,2.134,0,0,0,2.125,2.142H94.38A2.133,2.133,0,0,0,96.5,346.65V316.792a27.716,27.716,0,0,0-27.733-27.729Z",
    transform: "translate(0 59.804)",
    fill: "#dbe9ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7544",
    d: "M9.01,289.063a2.134,2.134,0,0,0-2.079,2.6l10.6,46.671v10.462h4.267V338.4l10.617-46.746a2.134,2.134,0,0,0-2.079-2.6Z",
    transform: "translate(29.907 59.804)",
    fill: "#33b9ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7546",
    d: "M4.5,311.451V296.484a2.134,2.134,0,1,1,4.268,0v14.968Z",
    transform: "translate(13.079 97.145)",
    fill: "#c8d4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7548",
    d: "M11.906,311.451V296.484a2.134,2.134,0,1,1,4.268,0v14.968Z",
    transform: "translate(65.403 97.145)",
    fill: "#c8d4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7550",
    d: "M6.879,287.74v12.787a2.225,2.225,0,0,0,.11.677,11.661,11.661,0,0,0,2.646,4.031,13.912,13.912,0,0,0,10.047,3.827,13.912,13.912,0,0,0,10.047-3.827,11.663,11.663,0,0,0,2.646-4.031,2.148,2.148,0,0,0,.11-.677V287.74Z",
    transform: "translate(29.895 50.463)",
    fill: "#fdce97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7552",
    d: "M9.823,289.063a27.887,27.887,0,0,0-4.267.326v23.137H9.823Z",
    transform: "translate(20.556 59.804)",
    fill: "#2f5c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7554",
    d: "M11.421,291.707a6.4,6.4,0,1,0,6.409,6.409A6.435,6.435,0,0,0,11.421,291.707Z",
    transform: "translate(16.817 78.481)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7556",
    d: "M7.683,292.237a2.134,2.134,0,1,1,0,4.268,2.134,2.134,0,0,1,0-4.268Z",
    transform: "translate(20.555 82.219)",
    fill: "#dbe9ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7558",
    d: "M10.847,289.063v21.321h4.271v-21a27.843,27.843,0,0,0-4.271-.326Z",
    transform: "translate(57.924 59.804)",
    fill: "#2f5c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7560",
    d: "M20.466,291.444A10.7,10.7,0,0,0,9.789,302.105v2.142a2.134,2.134,0,1,0,4.268,0v-2.142a6.4,6.4,0,0,1,12.8,0v2.142a2.134,2.134,0,1,0,4.268,0v-2.142a10.682,10.682,0,0,0-10.661-10.661Z",
    transform: "translate(50.449 76.619)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7566",
    d: "M29.44,283.508a2.133,2.133,0,0,0-1.921,1.463s-1.526,4.929-6.5,4.929H8.211a2.133,2.133,0,0,0-2.125,2.142v12.8a19.2,19.2,0,0,0,38.392,0v-12.8a2.133,2.133,0,0,0-2.125-2.142H38.086c-4.978,0-6.521-4.929-6.521-4.929a2.133,2.133,0,0,0-2.125-1.463Z",
    transform: "translate(24.294 20.554)",
    fill: "#fdd5a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysician);
export default __webpack_public_path__ + "static/media/physician.16e269d3ec4ab0c2919537ee993cbc63.svg";
export { ForwardRef as ReactComponent };